import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
import { SectionHeader } from './ui/SectionHeader';
const problems = [{
  title: 'Llegás al final del día agotado pero sin rumbo:',
  desc: 'Con una sensación de saturación extrema pero sin haber hecho lo importante.'
}, {
  title: 'Pensamientos que no progresan:',
  desc: 'Un bucle mental constante (rumiación) del que no sabés cómo salir.'
}, {
  title: 'Te quemás la cabeza seguido:',
  desc: 'Agotamiento mental crónico y dolores de cabeza por exceso de estímulos.'
}, {
  title: 'Siempre las mismas reacciones:',
  desc: 'Te frustrás o te paralizás ante el menor imprevisto, viviendo en piloto automático.'
}, {
  title: 'Estabilidad inalcanzable:',
  desc: 'Te falta un sistema estructurado para manejar el día a día.'
}, {
  title: 'Consejos sueltos de internet:',
  desc: 'Probás meditación, respiraciones sueltas o tips de redes, pero nada respalda un cambio real.'
}, {
  title: 'Sin saber autorregularte:',
  desc: 'Tu estabilidad emocional se vuelve un caos que depende 100% de los estímulos externos.'
}];
export function ProblemAgitation() {
  return <section className="py-24 px-6 border-b border-ink/10" data-id="element-111">
      <div className="max-w-editorial mx-auto" data-id="element-112">
        <SectionHeader number="02" title="🚨 ¿TE PASA ESTO SEGUIDO?" subtitle="Si vivís con ansiedad en el día a día, esto te va a sonar dolorosamente familiar:" data-id="element-113" />

        <div className="mt-12 space-y-6 max-w-3xl" data-id="element-114">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="flex items-start gap-4" data-id="element-115">
              <div className="mt-1 flex-shrink-0" data-id="element-116">
                <AlertTriangle size={20} className="text-oxblood" data-id="element-117" />
              </div>
              <p className="text-lg font-sans text-ink-light leading-relaxed" data-id="element-118">
                <strong className="text-ink font-semibold" data-id="element-119">
                  {problem.title}
                </strong>{' '}
                {problem.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-16 pt-12 border-t border-ink/10" data-id="element-120">
          <h3 className="text-2xl md:text-3xl font-serif text-oxblood text-center max-w-2xl mx-auto leading-tight" data-id="element-121">
            ¿Cuántos meses más vas a vivir atrapado en el piloto automático?
          </h3>
        </motion.div>
      </div>
    </section>;
}